import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import "../App.css";
import { FaAward, FaCertificate, FaShieldAlt, FaCheckCircle, FaSearchPlus, FaTimes } from "react-icons/fa";
import CategoriesGrid from "../Components/CategoriesGrid";
import WhyChooseUs from "../Components/WhyChooseUs";
import GeMSection from "../Components/GeMSection";

import HomeSlider1 from "../image/HomeSlider1.webp";
import HomeSlider2 from "../image/HomeSlider2.webp";
import HomeSlider3 from "../image/HomeSlider3.webp";
import AboutUsSection from "../image/AboutUsSection.webp";

import LuxuryImage1 from "../image/LuxuryImage1.webp";
import ManufacturingUnit from "../image/ManufacturingUnit.webp";
import CertRegistration from "../image/KAMDHENU STEEL INDUSTRIES - Certificate of Registration.jpg";

// Interactive Zoomable Image for Modal (Same as ProductDetails / Infrastructure Page)
const ZoomableImage = ({ src, alt }) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const [position, setPosition] = useState({ x: "50%", y: "50%" });

  const handleMouseMove = (e) => {
    if (!isZoomed) return;
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setPosition({ x: `${x}%`, y: `${y}%` });
  };

  const handleClick = () => {
    setIsZoomed(!isZoomed);
    if (isZoomed) {
      setPosition({ x: "50%", y: "50%" });
    }
  };

  return (
    <div
      className="zoom-container"
      style={{
        overflow: "hidden",
        cursor: isZoomed ? "zoom-out" : "zoom-in",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
      onMouseMove={handleMouseMove}
      onClick={handleClick}
    >
      <img
        src={src}
        alt={alt}
        className="gallery-main-img-dark"
        style={{
          transform: isZoomed ? "scale(2.2)" : "scale(1)",
          transformOrigin: `${position.x} ${position.y}`,
          transition: "transform 0.2s ease-out",
          width: "100%",
          height: "100%",
          maxHeight: "85vh",
          objectFit: "contain"
        }}
        draggable={false}
      />
    </div>
  );
};

function Homepage() {
  const [certModalOpen, setCertModalOpen] = useState(false);
  const [slides] = useState([
    {
      id: 1,
      image: HomeSlider1,
    },
    {
      id: 2,
      image: HomeSlider2,
    },
    {
      id: 3,
      image: HomeSlider3,
    }
  ]);

  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const intervalId = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 4000);
    return () => clearInterval(intervalId);
  }, [slides]);

  return (
    <>
      {/* Hero Section */}
      <section className="home-hero-section">
        <div className="hero-slider-wrapper">
          {slides.length > 0 ? (
            slides.map((slide, index) => (
              <div
                key={slide.id}
                className={`hero-slide ${index === activeIndex ? "active" : ""}`}
              >
                <img
                  src={slide.image}
                  alt={slide.name || `Slider ${index + 1}`}
                  className="hero-slide-image"
                  loading={index === 0 ? "eager" : "lazy"}
                />
              </div>
            ))
          ) : (
            <div className="hero-slide hero-slide-empty active" />
          )}
        </div>
      </section>

      {/* About Section - One Stop Solution */}
      <section className="section-padding light-section" id="about">
        <div className="container position-relative z-1">
          <div className="row align-items-center flex-column-reverse flex-md-row">
            <div className="col-12 col-md-6 mt-4 mt-md-0 pe-md-4 pe-lg-5 text-center text-md-start">
              <span className="section-pill mb-3">About Shree Kamdhenu Furniture</span>
              <h2 className="section-heading text-dark mb-3 mb-md-4 fs-3 fs-md-2">One Stop <span className="text-primary fst-italic">Solution</span></h2>
              <p className="text-muted-dark mb-4 fs-6 px-2 px-md-0" style={{ lineHeight: '1.8' }}>
                Shree Kamdhenu Furniture (Khodiyar Fabrication) is a trusted manufacturer of premium steel beds, designer box beds, laser CNC cupboards, and heavy-duty almirahs. We are committed to delivering top-quality steel furniture that forms the foundation of strong, stylish, and long-lasting spaces.
              </p>
              <Link to="/about" className="btn btn-primary rounded-pill px-4 py-2 mt-2 mt-md-3">View More &rarr;</Link>
            </div>
            <div className="col-12 col-md-6 text-center position-relative mb-4 mb-md-0">
              <div className="about-image-card white-card p-2 p-sm-3 p-md-3 mx-auto rounded-4 position-relative z-1" style={{ maxWidth: '100%', margin: '0 auto' }}>
                <img src={AboutUsSection} alt="Furniture" className="img-fluid rounded-3 shadow-sm w-100" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Collections Section */}
      <section className="section-padding dark-section" id="collections" style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}>
        <div className="container text-center position-relative z-1">
          <span className="section-pill mb-3">Style Spotlight</span>
          <h2 className="section-heading text-white mb-4 mb-md-5 fs-3 fs-md-2">Our <span className="text-primary fst-italic">Collections</span></h2>

          <CategoriesGrid />
        </div>
      </section>

      {/* Why Choose Us Section */}
      <WhyChooseUs />

      {/* GeM Registered Vendor Section */}
      <GeMSection />

      {/* Stats Banner */}
      <section className="stats-banner py-4 py-md-5" style={{
        background: `linear-gradient(rgba(198, 40, 40, 0.85), rgba(198, 40, 40, 0.95)), url(${ManufacturingUnit})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>
        <div className="container position-relative z-1">
          <div className="row align-items-center">
            <div className="col-lg-5 text-center text-lg-start mb-4 mb-lg-0">
              <h3 className="text-white font-serif mb-3 fs-4 fs-md-3">"Your Project Starts Here."</h3>
              <p className="text-white opacity-75 mb-4">Have a project in mind?</p>
              <a href="https://wa.me/919924382499?text=Hello!%20I%20would%20like%20to%20inquire%20about%20your%20furniture%20and%20products." target="_blank" rel="noopener noreferrer" className="btn btn-outline-light rounded-pill px-4 py-2 hover-lift">Inquiry Now</a>
            </div>
            <div className="col-lg-7 mb-0">
              <div className="row text-center border border-light border-opacity-25 p-3 p-md-4 rounded-4" style={{ background: 'rgba(0,0,0,0.1)' }}>
                <div className="col-4 border-end border-light border-opacity-25">
                  <h2 className="text-white fw-bold mb-1 fs-3 fs-md-2">32+</h2>
                  <p className="text-white opacity-75 small mb-0 fs-7">Years Of Experience</p>
                </div>
                <div className="col-4 border-end border-light border-opacity-25">
                  <h2 className="text-white fw-bold mb-1 fs-3 fs-md-2">99%</h2>
                  <p className="text-white opacity-75 small mb-0 fs-7">Client Satisfied</p>
                </div>
                <div className="col-4">
                  <h2 className="text-white fw-bold mb-1 fs-3 fs-md-2">500+</h2>
                  <p className="text-white opacity-75 small mb-0 fs-7">Happy Clients</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Discover Premium Steel Beds & Cupboards Section */}
      <section className="section-padding text-center position-relative" style={{
        background: `linear-gradient(rgba(15, 23, 42, 0.75), rgba(15, 23, 42, 0.9)), url(${LuxuryImage1})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>
        <div className="glowing-orb primary top-0 start-50 translate-middle-x" style={{ width: '400px', height: '400px' }}></div>
        <div className="container position-relative z-1">
          <h2 className="font-serif text-white display-6 display-md-5 fw-bold mb-3">Premium Steel Beds<br />& Designer Cupboards</h2>
          <p className="text-light opacity-75 mx-auto px-2 px-md-0" style={{ maxWidth: '600px' }}>
            At Shree Kamdhenu Furniture, we deliver high-grade ISI steel beds, cushion beds, laser cut cupboards, and dressing almirahs that combine heavy-duty strength, long durability, and modern design.
          </p>
        </div>
      </section>

      {/* Testimonials / Google Reviews Section */}
      <section className="section-padding light-section">
        <div className="container text-center position-relative z-1">
          <span className="section-pill mb-3">Google Reviews</span>
          <h2 className="section-heading text-dark mb-3 mb-md-4 fs-3 fs-md-2">Quality That <span className="text-primary fst-italic">Our Clients Speak For</span></h2>
          <p className="text-muted-dark mx-auto mb-4 mb-md-5 px-2 px-md-0" style={{ maxWidth: '700px' }}>
            Our clients' words reflect our commitment to quality, craftsmanship, and reliable service. Every bed and cupboard we deliver is built on trust, precision, and satisfaction.
          </p>

          {/* Elfsight Google Reviews Widget - Loaded via iframe to prevent styled-components crash in SPA */}
          <iframe 
            src="/google-reviews.html" 
            title="Google Reviews" 
            style={{ width: '100%', height: '550px', border: 'none', overflow: 'hidden' }}
            scrolling="no"
          ></iframe>
        </div>
      </section>

      {/* Masterpiece Craftsmanship & Official Certifications Section */}
      <section className="section-padding premium-cert-section text-center position-relative overflow-hidden">
        <div className="container position-relative z-1">
          <span className="section-pill mb-3">Certified Quality & Standards</span>

          <h2 className="section-heading text-dark mb-3 fs-3 fs-md-2">
            Official <span className="text-primary fst-italic">ISO 9001:2015 Registration</span>
          </h2>

          <p className="text-muted-dark mx-auto mb-4 mb-md-5 px-2 px-md-0" style={{ maxWidth: '750px', fontSize: '1.05rem', lineHeight: '1.7' }}>
            Shree Kamdhenu Furniture operates under verified quality management standards, certified for high-grade manufacturing, durability, and customer trust.
          </p>

          {/* Certificate Showcase Card */}
          <div className="row justify-content-center g-4">
            <div className="col-12 col-md-9 col-lg-7">
              <div
                className="white-card p-3 p-md-4 rounded-4 shadow-sm border transition-all hover-lift overflow-hidden"
                style={{ maxWidth: '650px', margin: '0 auto' }}
              >
                {/* Top Badge Banner */}
                <div className="d-flex align-items-center justify-content-between mb-3 px-1 px-sm-2">
                  <span className="badge bg-primary text-white fw-semibold px-3 py-2 rounded-pill d-flex align-items-center gap-2" style={{ fontSize: '0.85rem', letterSpacing: '0.5px' }}>
                    <FaCertificate /> ISO 9001:2015 CERTIFIED
                  </span>
                  <button
                    onClick={() => setCertModalOpen(true)}
                    className="btn btn-sm btn-outline-danger rounded-pill px-3 py-1 d-flex align-items-center gap-1 hover-lift"
                    style={{ fontSize: '0.8rem' }}
                  >
                    <FaSearchPlus /> Click to View & Zoom
                  </button>
                </div>

                {/* Certificate Image Frame */}
                <div
                  className="position-relative cursor-pointer rounded-3 overflow-hidden bg-light p-2 border"
                  onClick={() => setCertModalOpen(true)}
                >
                  <img
                    src={CertRegistration}
                    alt="Kamdhenu Steel Industries Certificate of Registration"
                    className="img-fluid rounded-3"
                    style={{
                      maxHeight: '560px',
                      objectFit: 'contain',
                      width: '100%'
                    }}
                  />
                </div>

                {/* Card Footer Features */}
                <div className="row g-2 mt-3 pt-3 border-top text-start">
                  <div className="col-12 col-sm-4 text-center text-sm-start">
                    <div className="d-flex align-items-center justify-content-center justify-content-sm-start gap-2 text-primary small fw-bold">
                      <FaCheckCircle /> Quality Management
                    </div>
                  </div>
                  <div className="col-12 col-sm-4 text-center">
                    <div className="d-flex align-items-center justify-content-center gap-2 text-dark small fw-bold">
                      <FaShieldAlt /> Government Registered
                    </div>
                  </div>
                  <div className="col-12 col-sm-4 text-center text-sm-end">
                    <div className="d-flex align-items-center justify-content-center justify-content-sm-end gap-2 text-success small fw-bold">
                      <FaAward /> Verified Manufacturer
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fullscreen Certificate Preview Modal (ProductDetails Style) */}
      <Modal
        show={certModalOpen}
        onHide={() => setCertModalOpen(false)}
        centered
        size="xl"
        className="gallery-modal-dark"
        backdropClassName="gallery-backdrop-dark"
        fullscreen={true}
      >
        <Modal.Body className="p-0 gallery-modal-body-dark">
          <div className="gallery-header">
            <div className="gallery-header-left">
              <h5 className="gallery-title">Certificate of Registration</h5>
              <span className="gallery-subtitle">Click to zoom image</span>
            </div>
            <div className="gallery-header-right">
              <button onClick={() => setCertModalOpen(false)} className="gallery-close-btn-dark">
                <FaTimes />
              </button>
            </div>
          </div>

          <div className="gallery-main-view-dark">
            <div className="gallery-image-wrapper">
              <ZoomableImage src={CertRegistration} alt="KAMDHENU STEEL INDUSTRIES - Certificate of Registration" />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Homepage;
